import React from "react";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import { CustomInputBase } from "./CustomInputBase";
import { Box } from "@mui/material";

interface InputFieldProps {
  value: string;
  label: string;
  id: string;
  name: string;
  autoComplete?: string;
  autoFocus?: boolean;
  type?: string;
  placeholder?: string;
  error: boolean;
  helperText: any;
  startAdornment?: any;
  endAdornment?: any;
  customLabelSx?: any;
  onBlur?: (event: any) => void;
  onFocus?: (event: any) => void;
  onChange?: (event: any) => void;
  onClick?: () => void;
  sx?: any;
}

function CustomInput({
  value,
  label,
  id,
  autoComplete,
  autoFocus = false,
  type = "text",
  placeholder,
  error,
  helperText,
  startAdornment,
  endAdornment,
  onBlur,
  onFocus,
  onChange,
  onClick,
  customLabelSx,
  ...rest
}: InputFieldProps) {
  // const inputRef = useRef<HTMLElement>(null);

  return (
    <Box>
      <InputLabel
        sx={{ fontSize: "14px", marginBottom: "4px", ...customLabelSx }}
      >
        {label}
      </InputLabel>

      <FormControl sx={{ width: "100%" }}>
        <CustomInputBase
          onClick={onClick}
          value={value}
          placeholder={placeholder}
          // sx={{ marginBottom: '20px' }}
          type={type}
          id={id}
          autoFocus={autoFocus}
          spellCheck={false}
          onBlur={onBlur}
          autoComplete={autoComplete}
          onFocus={onFocus}
          onChange={onChange}
          startAdornment={startAdornment}
          endAdornment={endAdornment}
          error={error}
          {...rest}
        />
        {error && <FormHelperText error>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
}

export default CustomInput;
